<template>
    <div class="clientForm">
        <div class="row">
            <div class="col-sm-12 d-flex flex-column mb-3">
                <label>Name:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter bold" v-model="customer.name" @input="emitChange">
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Country:</label>

                <country-picker :topCodes="topCountries" openDirection="bottom" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event, 'country')" :customClass="'mb-2'" :error="!selectedCountry" ></country-picker>
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1">
                <label>Phone:</label>
                <PhoneInput
                    ref="phoneInput"
                    v-model="customer.phone"
                    :country="phoneCountry"
                    @input="onPhoneInput"
                    @validate="isPhoneValid"
                    @country-changed="onFlagChanged"
                />
                <div v-if="customer.phone && !customerPhoneValid" class="error">
                    <span>Phone Number Invalid.</span>
                </div>
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Hotel:</label>

                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.accomodation" @input="emitChange">
            </div>

            <div class="col-sm-6 d-flex flex-column mt-1 mb-3">
                <label>Room:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.room" @input="emitChange">
            </div>

            <div class="col-sm-12 d-flex flex-column mt-1 mb-3">
                <label :class="{'color-6': !$v.customer.email.email}">Email:</label>
                
                <input :disabled="disabled" type="text" class="fs-bigger bg-lighter" v-model="customer.email" @input="emitChange">
                
                <span v-if="!$v.customer.email.email" class="color-6 fs-smaller">
                    <span v-if="!$v.customer.email.email">Invalid email</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { email } from 'vuelidate/lib/validators'

    import extendedVSelect from '@/extends/vue-select'
    import CountryPicker from '@/tools/CountryPicker'
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import phoneCountrySync from '@/mixins/phoneCountrySync';
    import { TOP_COUNTRY_CODES } from '@/enums/topCountries';
    export default {
        mixins: [phoneCountrySync],
        data() {
            return {
                customerPhoneValid: true,
                selectedCountry: null,
                topCountries: TOP_COUNTRY_CODES,
            }
        },
        props: {
            customer:{
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        validations: {
            customer: {
                email: {
                    email
                }
            }
        },
        mounted() {
            this.setDefaults();
        },
        computed: {
            ...mapGetters([
                'getCountries'
            ]),
        },
        methods: {
            emitChange() {
                this.$emit('input');
            },
            isPhoneValid(phoneObj) {
                this.customerPhoneValid = !!phoneObj.valid;
                if (this.isPhoneInputInitialized) {
                    const dial = phoneObj.countryCallingCode ? `+${String(phoneObj.countryCallingCode)}` : null;
                    if (this.customer.dial !== dial) {
                        this.$set(this.customer, 'dial', dial);
                    }
                }
                this.$emit('phone-valid', this.customerPhoneValid);
            },
            onFlagChanged(country) {
                // Prevent initial country-change from mutating flag
                if (!this.isPhoneInputInitialized) return;

                const dial = country.dial;
                if (this.customer.dial !== dial) {
                    this.$set(this.customer, 'dial', dial);
                }

                if (dial && this.customer.phone && !this.customer.phone.startsWith(dial)) {
                    this.customer.phone = dial;
                }

                if (this.isChangingCountryFromPicker) {
                    this.isChangingCountryFromPicker = false;
                    return;
                }

                // Sync country picker with the country detected from phone input
                if (country.iso2) {
                    const matchedCountry = this.getCountries.find(c => c.code2 === country.iso2);
                    if (matchedCountry && (!this.selectedCountry || this.selectedCountry.id !== matchedCountry.id)) {
                        this.selectedCountry = matchedCountry;
                        this.applyCountryInfo(matchedCountry);
                        this.emitChange();
                    }
                }
            },
            setDefaults() {
                const defaultCountry = this.getCountries.find(c => c.default);
                this.selectedCountry = this.getCountries.find(c => c.id === this.customer.country) || defaultCountry;
                this.phoneCountry = this.selectedCountry ? this.selectedCountry.code2 : null;

            },
            updateCountry(event = null, type) {
                this.selectedCountry = event;

                if (type === 'country') {
                    this.applyCountryInfo(this.selectedCountry);
                    this.isChangingCountryFromPicker = true;
                    this.customer.phone = '';
                    this.phoneCountry = this.selectedCountry.code2;
                    this.$refs.phoneInput.$refs.telInput.choose(this.selectedCountry.code2);
                }

                this.emitChange();
            },
            applyCountryInfo(country) {
                this.customer.country = country.id;
                this.customer.countryName = country.name;
            },
            resetCountryInfo() {
                this.customer.country = null;
                this.customer.countryName = '';
                this.selectedCountry = null;
            },
        },
        components: {
            vSelect: extendedVSelect,
            CountryPicker,
            PhoneInput
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_utility.scss';

    label {
        width: 80px;
        min-width: 80px;
    }

    input {
        width: 100%;

        &.clickable {
            border-color: $lightest;
            @extend .darker;
        }
    }

    textarea {
        width: 100%;
        padding: 0.2rem 0.45rem;
    }
</style>



// WEBPACK FOOTER //
// ClientForm.vue?7bc7a838